import { useQuery } from '@tanstack/react-query';
import { getOrgConversations, getOrgConversationDetail } from '../api/conversations';

export function useOrgConversations(orgId: string | null) {
  return useQuery({
    queryKey: ['org-conversations', orgId],
    queryFn: () => getOrgConversations(orgId!),
    enabled: Boolean(orgId),
    refetchInterval: 15000,
    refetchIntervalInBackground: false,
  });
}

export function useOrgConversationDetail(orgId: string | null, conversationId: string | null) {
  return useQuery({
    queryKey: ['org-conversation', orgId, conversationId],
    queryFn: () => getOrgConversationDetail(orgId!, conversationId!),
    enabled: Boolean(orgId && conversationId),
    refetchInterval: 10000,
    refetchIntervalInBackground: false,
  });
}
